import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { User } from "src/classes/Automation/UserApp";
import { AdminPanel_Parameters } from "src/classes/Automation/adminpanel_parameters";
import { SetTemplateValid } from "src/classes/Automation/TemplatesSave";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: "app-childadminpanel",
    templateUrl: "./childadminpanel.component.html",
    providers: [HttpService1],
    styleUrls: ["./childadminpanel.component.css"],
})
export class ChildadminpanelComponent implements OnInit {
    adminpanel_params: AdminPanel_Parameters = new AdminPanel_Parameters();
    initialAdminPanelParams: AdminPanel_Parameters = new AdminPanel_Parameters();
    receivedsettemplatevalid: SetTemplateValid = new SetTemplateValid();
    user: User = new User();

    isPhoneToCallValid: boolean = true;
    isFirstPhoneToSendValid: boolean = true;
    isSecondPhoneToSendValid: boolean = true;
    isFirstPhoneToSendWarningValid: boolean = true;
    isSecondPhoneToSendWarningValid: boolean = true;

    isConfirmDialogVisible: boolean = false;

    isSizeValid: boolean = true;
    isFileValid: boolean = true;

    isPreviewVisible: boolean = false;

    @ViewChild("inputPhoneToCall", { static: false }) inputPhoneToCall: ElementRef<HTMLInputElement>;
    @ViewChild("inputFirstPhoneToSendCancel", { static: false }) inputFirstPhoneToSendCancel: ElementRef<HTMLInputElement>;
    @ViewChild("inputSecondPhoneToSendCancel", { static: false }) inputSecondPhoneToSendCancel: ElementRef<HTMLInputElement>;
    @ViewChild("inputFirstPhoneToSendInform", { static: false }) inputFirstPhoneToSendInform: ElementRef<HTMLInputElement>;
    @ViewChild("inputSecondPhoneToSendInform", { static: false }) inputSecondPhoneToSendInform: ElementRef<HTMLInputElement>;

    constructor(
        private dynamicDialogService: DynamicDialogService,
        private httpService1: HttpService1,
        private logger: NGXLogger
    ) { }

    ngOnInit() {
        this.user.useremail = sessionStorage.getItem("email");

        this.httpService1.getDataAdminPanel(this.user)
            .subscribe((data: AdminPanel_Parameters) => {
                this.adminpanel_params = data;
                this.initialAdminPanelParams = { ...this.adminpanel_params };
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    closeDialog(): void {
        if (JSON.stringify(this.initialAdminPanelParams) != JSON.stringify(this.adminpanel_params)) {
            this.isConfirmDialogVisible = true;
        }
        else {
            this.dynamicDialogService.closeDialog();
        }
    }

    closeConfirmDialog(isAccepted: boolean): void {
        this.isConfirmDialogVisible = false;

        if (isAccepted) {
            this.dynamicDialogService.closeDialog();
        }
    }

    uploadImage(target: HTMLInputElement): void {
        const file: File = target.files[0];

        this.isFileValid = file.type == "image/jpeg" || file.type == "image/png";
        this.isSizeValid = file.size < 40 * 1024;

        if (this.isFileValid && this.isSizeValid) {
            this.toDataURL(URL.createObjectURL(file)).then(data => {
                this.adminpanel_params.logo = data;
            });
        }
    }

    // Get file url and convert it to base64 that can be used as image src
    async toDataURL(url: string): Promise<string> {
        const response = await fetch(url);
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    clearLogo(): void {
        this.adminpanel_params.logo = "";
        this.isFileValid = true;
        this.isSizeValid = true;
    }

    callOptionChange(): void {
        this.isPhoneToCallValid = true;

        if (!this.adminpanel_params.showCallOption) {
            this.adminpanel_params.phoneToCall = "";
        }
    }

    cancelOptionChange(): void {
        if (!this.adminpanel_params.showCancelOption) {
            this.adminpanel_params.canSendSmsonCancel = false;
            this.adminpanel_params.canSendSmsToInform = false;

            this.sendCancelMeetingChange();
            this.sendWarningChange();
        }
    }

    timeValueDecrement(limit: number): void {
        if (this.adminpanel_params.allowCancelBeforeHours > limit) {
            this.adminpanel_params.allowCancelBeforeHours--;
        }
    }

    timeValueIncrement(limit: number): void {
        if (this.adminpanel_params.allowCancelBeforeHours < limit) {
            this.adminpanel_params.allowCancelBeforeHours++;
        }
    }

    onRangeFocus(target: HTMLInputElement): void {
        target.select();
    }

    onRangeChange(eventTarget: HTMLInputElement, minValue?: number, maxValue?: number): void {
        this.adminpanel_params.allowCancelBeforeHours = +this.adminpanel_params.allowCancelBeforeHours.toString().replace(/[^0-9*#]/g, "");

        if (minValue && this.adminpanel_params.allowCancelBeforeHours < minValue) {
            this.adminpanel_params.allowCancelBeforeHours = minValue;
        }
        if (maxValue && this.adminpanel_params.allowCancelBeforeHours > maxValue) {
            this.adminpanel_params.allowCancelBeforeHours = maxValue;
        }

        eventTarget.value = this.adminpanel_params.allowCancelBeforeHours.toString();
    }

    sendCancelMeetingChange(): void {
        this.isFirstPhoneToSendValid = true;
        this.isSecondPhoneToSendValid = true;

        if (!this.adminpanel_params.canSendSmsonCancel) {
            this.adminpanel_params.phoneToSendonCancel1 = "";
            this.adminpanel_params.phoneToSendonCancel2 = "";
        }
    }

    sendWarningChange(): void {
        this.isFirstPhoneToSendWarningValid = true;
        this.isSecondPhoneToSendWarningValid = true;

        if (!this.adminpanel_params.canSendSmsToInform) {
            this.adminpanel_params.phoneToSendToInform2 = "";
            this.adminpanel_params.phoneToSendToInform1 = "";
        }
    }

    getTextLength(): number {
        return this.adminpanel_params.afterConfMsg ? this.adminpanel_params.afterConfMsg.length : 0;
    }

    showPreview(): void {
        this.isPreviewVisible = true;
    }

    hidePreview(): void {
        this.isPreviewVisible = false;
    }

    saveData(): void {
        this.isPhoneToCallValid = true;
        this.isFirstPhoneToSendValid = true;
        this.isSecondPhoneToSendValid = true;
        this.isFirstPhoneToSendWarningValid = true;
        this.isSecondPhoneToSendWarningValid = true;

        if (this.adminpanel_params.showCallOption) {
            if (!this.inputPhoneToCall.nativeElement.validity.valid || this.adminpanel_params.phoneToCall == "") {
                this.isPhoneToCallValid = false;
            }
        }

        if (this.adminpanel_params.canSendSmsonCancel) {
            if (!this.inputFirstPhoneToSendCancel.nativeElement.validity.valid ||
                (this.adminpanel_params.phoneToSendonCancel1 == "" && this.adminpanel_params.phoneToSendonCancel2 == "")) {
                this.isFirstPhoneToSendValid = false;
            }

            if (!this.inputSecondPhoneToSendCancel.nativeElement.validity.valid ||
                (this.adminpanel_params.phoneToSendonCancel1 == this.adminpanel_params.phoneToSendonCancel2 && this.isFirstPhoneToSendValid)) {
                this.isSecondPhoneToSendValid = false;
            }
        }

        if (this.adminpanel_params.canSendSmsToInform) {
            if (!this.inputFirstPhoneToSendInform.nativeElement.validity.valid ||
                (this.adminpanel_params.phoneToSendToInform1 == "" && this.adminpanel_params.phoneToSendToInform2 == "")) {
                this.isFirstPhoneToSendWarningValid = false;
            }

            if (!this.inputSecondPhoneToSendInform.nativeElement.validity.valid ||
                (this.adminpanel_params.phoneToSendToInform1 == this.adminpanel_params.phoneToSendToInform2 && this.isFirstPhoneToSendWarningValid)) {
                this.isSecondPhoneToSendWarningValid = false;
            }
        }

        if (this.isPhoneToCallValid &&
            this.isFirstPhoneToSendValid && this.isSecondPhoneToSendValid &&
            this.isFirstPhoneToSendWarningValid && this.isSecondPhoneToSendWarningValid) {
            this.httpService1.setDataAdminPanel(this.user, this.adminpanel_params).subscribe((res: SetTemplateValid) => {
                this.receivedsettemplatevalid = res;
                console.log("Sources data saved: " + this.receivedsettemplatevalid.answer);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

            this.dynamicDialogService.closeDialog();
        }
    }
}
